import React, { useState } from 'react';
import { TableHeadersType } from '../../../constant/tableHeadersConstants/tableHeadersType';
import { UserGrouptype } from '../../../redux/userManagement/userManagementTypes';
import { formateDateWithTime } from '../../../utils/commonFunctions';
import { useSelector } from 'react-redux';
import { RootState } from '../../../redux/rootReducers';

type AppProps = {
  data: [] | UserGrouptype[];
  tableHeaders: TableHeadersType[];
  isEditUserGroupsPresent: boolean;
  handleRedirectToEditUserGroup: (menuGroupId: number | undefined) => void;
}

const UserGroupTableData = ({
  data,
  tableHeaders,
  handleRedirectToEditUserGroup,
  isEditUserGroupsPresent
}: AppProps) => {
  let superAdminEmailsString = process.env.REACT_APP_SUPER_ADMIN || "[]"
  let superAdminEmails = JSON.parse(
    superAdminEmailsString
  );
  const email = useSelector((state: RootState) => state.auth.loginData?.email);
  const exists = superAdminEmails?.some(
    (el: string) => el?.toLowerCase() === email?.toLowerCase()
  );
  const renderDefaultUserGroupTable = () => {
    const finalTableData = data?.length > 0 && data?.map((userGroupData: any) => {
      if (userGroupData?.is_default === 1) {
        return (
          <tr key={userGroupData?.group_id}>
            {tableHeaders?.length > 0 && tableHeaders?.map((item: TableHeadersType) => {
              if (item.value === 'group_name') {
                return <td className='text-center'>
                  {userGroupData?.group_name}
                  {userGroupData?.is_default ? <span className="new-chip">Default</span> : null}
                </td>
              } else if (item.value === 'updated_by_first_name') {
                return <td className='text-center'>
                  {`${userGroupData?.updated_by_first_name} ${userGroupData?.updated_by_last_name}`}<br />
                  <span className='text-muted'>{formateDateWithTime(userGroupData?.updated_at)}</span>
                </td>
              }
            })}
            <td style={{ width: '50px' }} className='text-center'>
              {exists ? <span
                className="d-inline-block pointer"
                onClick={() => handleRedirectToEditUserGroup(userGroupData?.group_id)}>
                <img src="/img/icons/IconEdit.svg" />
              </span> : null}
            </td>
          </tr>
        )
      }
    });

    return finalTableData;
  }

  const renderTableData = () => {
    const finalTableData = data?.length > 0 && data?.map((userGroupData: any) => {
      if (userGroupData?.is_default === 0) {
        return (
          <tr key={userGroupData?.group_id}>
            {tableHeaders?.length > 0 && tableHeaders?.map((item: TableHeadersType) => {
              if (item.value === 'group_name') {
                return <td className='text-center'>
                  {userGroupData?.group_name}
                  {userGroupData?.is_default ? <span className="new-chip">Default</span> : null}
                </td>
              } else if (item.value === 'updated_by_first_name') {
                return <td className='text-center'>
                  {`${userGroupData?.updated_by_first_name} ${userGroupData?.updated_by_last_name}`}<br />
                  <span className='text-muted'>{formateDateWithTime(userGroupData?.updated_at)}</span>
                </td>
              }
            })}
            <td style={{ width: '50px' }} className='text-center'>
              <span
                className="d-inline-block pointer"
                onClick={() => handleRedirectToEditUserGroup(userGroupData?.group_id)}>
                <img src="/img/icons/IconEdit.svg" />
              </span>
            </td>
          </tr>
        )
      }
    });

    return finalTableData;
  }

  return (
    <>
      {renderDefaultUserGroupTable()}
      {renderTableData()}
    </>
  )
};

export default UserGroupTableData;